import { render, staticRenderFns } from "./ModifyResults.template.vue?vue&type=template&id=0e15a498&scoped=true&"
var script = {}
import style0 from "./ModifyResults.template.vue?vue&type=style&index=0&id=0e15a498&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15a498",
  null
  
)

export default component.exports